import { render, staticRenderFns } from "./BonusRecord.vue?vue&type=template&id=7fc85a8b&"
import script from "./BonusRecord.vue?vue&type=script&lang=js&"
export * from "./BonusRecord.vue?vue&type=script&lang=js&"
import style0 from "./BonusRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports